import { render } from "./KaratayButtonSvg.vue?vue&type=template&id=97ce4814"
import script from "./KaratayButtonSvg.vue?vue&type=script&lang=js"
export * from "./KaratayButtonSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__